'use client';

/* eslint-disable unused-imports/no-unused-vars -- ложное срабатывание: члены enum используются по всему проекту */
export enum YM_TARGETS_ENUM {
  GO_TO_MASTERCLASSES = 'GO_TO_MASTERCLASSES',
  ADD_TO_CART = 'ADD_TO_CART',
  SINC_LOCAL_CART = 'SINC_LOCAL_CART',
  DELETE_FROM_CART = 'DELETE_FROM_CART',
  CLEAR_CART = 'CLEAR_CART',
  ADD_TO_FAVORITES = 'ADD_TO_FAVORITES',
  DELETE_FROM_FAVORITES = 'DELETE_FROM_FAVORITES',
  GO_TO_PAYMENT = 'GO_TO_PAYMENT',
  EVENT = 'event',
  OPEN_NEW_YEAR_GAME_MODAL = 'OPEN_NEW_YEAR_GAME_MODAL',
  START_NEW_YEAR_GAME = 'START_NEW_YEAR_GAME',
  WIN_NEW_YEAR_GAME = 'WIN_NEW_YEAR_GAME',
  LOSE_NEW_YEAR_GAME = 'LOSE_NEW_YEAR_GAME',
}
/* eslint-enable unused-imports/no-unused-vars */

export const YM_COUNTER_ID = 97895732;

export const sendYMEvent = (
  target: YM_TARGETS_ENUM,
  params?: Record<string, any>,
) => {
  if (typeof window === 'undefined') {
    return;
  }
  // Метрика подключается lazyOnload: если tag.js ещё не загрузился,
  // создаём официальный стаб-очередь — tag.js отправит события после загрузки.
  // @ts-ignore
  window.ym =
    // @ts-ignore
    window.ym ||
    function () {
      // @ts-ignore
      (window.ym.a = window.ym.a || []).push(arguments);
    };
  // @ts-ignore
  window.ym(YM_COUNTER_ID, 'reachGoal', target, params);
};
